import { render, staticRenderFns } from "./randomWork.vue?vue&type=template&id=1ca2ee2d&"
import script from "./randomWork.vue?vue&type=script&lang=ts&"
export * from "./randomWork.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports